import {FieldValidatorType} from "@progress/kendo-react-form";

export const maxNumber100Validator: FieldValidatorType = (value: any) => {
    return (parseInt(value)<=100 && parseInt(value)>= 0) || (value === undefined) || (value === "") || (value === null)  ? "" : "Il valore massimo è 100";
}


